import { requestGet, requestPost } from '../request';
import axios from 'axios';
import apiPath from './apiPath';
const api = {
  GetOutletCodes(payload) {
    return requestGet(apiPath.OUTLETLIST.path, payload);
  },

  GetDownloadOrders(payload) {
    return requestGet(apiPath.ORDEREXPORT.path, payload);
  },

  DownLoadOrders(payload) {
    return axios({
      method: 'get',
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_BO_LIST_BY_MENU_ITEMS.path
      }`,
      params: {
        uid: payload.uid,
        order_type: payload.order_type,
        order_status: payload.order_status,
        start_time: payload.start_time,
        end_time: payload.end_time,
        outlet_code: payload.outlet_code
      }
    });
  },

  CreateExportAuditLog(payload) {
    return requestPost(apiPath.EXPORT_AUDIT.path, payload);
  }
};

export default api;
